var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdnaclas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.25C9.62335 10.25 11.75 8.12335 11.75 5.5C11.75 2.87665 9.62335 0.75 7 0.75C4.37665 0.75 2.25 2.87665 2.25 5.5C2.25 8.12335 4.37665 10.25 7 10.25Z",
    stroke: "#675D75",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.25C7.9665 7.25 8.75 6.4665 8.75 5.5C8.75 4.5335 7.9665 3.75 7 3.75C6.0335 3.75 5.25 4.5335 5.25 5.5C5.25 6.4665 6.0335 7.25 7 7.25Z",
    stroke: "#675D75",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7858 12.2477C12.3588 11.5387 11.4373 11.3092 10.7268 11.7367C8.48134 13.0892 5.51834 13.0892 3.27234 11.7367C2.56234 11.3092 1.64084 11.5387 1.21334 12.2477C0.785843 12.9572 1.01484 13.8792 1.72434 14.3067C2.66484 14.8732 3.68834 15.2772 4.75134 15.5162L1.63034 18.7487C1.07984 19.3677 1.13584 20.3162 1.75484 20.8662C2.37384 21.4162 3.32184 21.3607 3.87234 20.7417L6.99984 17.5032L10.1283 20.7422C10.4248 21.0757 10.8363 21.2457 11.2498 21.2457C11.6043 21.2457 11.9598 21.1207 12.2458 20.8667C12.8648 20.3162 12.9208 19.3682 12.3703 18.7492L9.24734 15.5167C10.3108 15.2777 11.3343 14.8737 12.2748 14.3072C12.9843 13.8792 13.2133 12.9572 12.7858 12.2477Z",
    stroke: "#675D75",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdnaclas);
export default __webpack_public_path__ + "static/media/Odnaclas.7b483c877b4b07ee0216de5d9053e404.svg";
export { ForwardRef as ReactComponent };